import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState } from 'react';
import { useCommonContext, usePurchaseHistoryContext, } from '../../../hooks/useContexts';
import { AddReceiptButton, BuildertrendButton, ExportButton, PrintButton, QuickBooksButton, } from './index';
var renderBuilderTrendButton = function (customerType) {
    if (customerType === 'b2b') {
        return (React.createElement("div", { style: { padding: 15 } },
            React.createElement(BuildertrendButton, null)));
    }
    return null;
};
var renderQuickBooksButton = function (customerType, request, setAlertState, orderLength, orderHistoryLoaded) {
    if (customerType === 'b2b' && orderLength > 0 && orderHistoryLoaded) {
        return (React.createElement("div", { style: { padding: 15 } },
            React.createElement(QuickBooksButton, { request: request, setAlertState: setAlertState })));
    }
    return null;
};
export var OrderHistoryHeader = function () {
    var svocID = useThdCustomer().svocID;
    var isDesktop = useCommonContext().isDesktop;
    var _a = usePurchaseHistoryContext(), setAlertState = _a.setAlertState, orderHistoryData = _a.orderHistoryData, orderHistoryLoaded = _a.orderHistoryLoaded, pHRequest = _a.pHRequest, customerType = _a.customerType;
    var _b = useState(false), renderBTBtn = _b[0], setRenderBTBtn = _b[1];
    var totalNumberOfOrders = (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.itemsCount) || 0;
    // TODO: temp solution to prevent buttons from rendering before the page is fully loaded
    // Reason: buildertrend button taking on style from add receipt button
    setTimeout(function () {
        setRenderBTBtn(true);
    }, 1000);
    return (React.createElement("div", { className: "no-print sui-flex sui-justify-end sui-items-center sui-h-full", "data-testid": "purchase-history-page-layout-header" },
        isDesktop && renderBTBtn && renderBuilderTrendButton(customerType),
        isDesktop &&
            renderQuickBooksButton(customerType, pHRequest, setAlertState, totalNumberOfOrders, orderHistoryLoaded),
        isDesktop &&
            customerType === 'b2b' &&
            totalNumberOfOrders > 0 &&
            orderHistoryLoaded && (React.createElement(ExportButton, { orderHistoryRequest: pHRequest, setAlertState: setAlertState, totalNumberOfOrders: totalNumberOfOrders })),
        isDesktop &&
            customerType === 'b2b' &&
            totalNumberOfOrders > 0 &&
            orderHistoryLoaded && (React.createElement(PrintButton, { orderHistory: pHRequest, setAlertState: setAlertState })),
        customerType === 'b2b' && (React.createElement("div", { style: { maxWidth: 200, padding: 15 } },
            React.createElement(AddReceiptButton, { svocId: svocID })))));
};
